import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./ProductsFilter/ProductsFilterReducer";
import UIReducer from "./UI/UIReducer";
import CartReducer from "./Cart/CartReducer";
import WishlistReducer from "./Wishlist/WishlistReducer";
const store = configureStore({
  reducer: {
    Filter: filterReducer,
    UI: UIReducer,
    Cart: CartReducer,
    Wishlist: WishlistReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
export default store;
